export { default } from "./documentObjectTypeIcon";
